import React from 'react';
import { FaFilePen } from "react-icons/fa6";
import { FaFileCircleCheck } from "react-icons/fa6";
import './EdSiderFindExams.css';

export default function ExamsHeaderTabs({
    showHeader = true,
    value = 0,
    handleChange = () => { },
    customerPaperText = 'Exams',
    availablePaperControl = false,
    enrollPaperControl = false,
}) {
    if (!showHeader) return null;

    return (
        <>
            <div className="ed-exams-header">
                <div className="ed-exams-left">
                    <h1 className="ed-exams-title">Exams</h1>
                    <p className="ed-exams-subtitle">Manage your active registrations and explore new testing opportunities.</p>
                </div>
            </div>

            <div className="ed-custom-tabs-wrapper">
                <div className="ed-custom-tabs">
                    <button
                        className={`ed-custom-tab ${value === 0 ? 'active' : ''}`}
                        onClick={() => handleChange(null, 0)}
                    >
                        <span className="tab-icon"><FaFilePen /></span>
                        Available {customerPaperText}
                    </button>
                    <button
                        className={`ed-custom-tab ${value === 1 ? 'active' : ''}`}
                        onClick={() => handleChange(null, 1)}
                    >
                        <span className="tab-icon"><FaFileCircleCheck /></span>
                        Enrolled {customerPaperText}
                    </button>
                </div>
            </div>
        </>
    );
}
